import React, { useEffect, useState } from "react";
import "../../cssfiles/homepage.css";
import CustomButton from "../CommonComponents/CustomButton";
import {
  Box,
  Dialog,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import CustomActionButton from "../CommonComponents/CustomActionButton";
import { useSelector } from "react-redux";
import CustomLabel from "../CommonComponents/CustomLabel";
import CustomDropDown from "../CommonComponents/CustomDropDown";
import CustomTextField from "../CommonComponents/CustomTextField";
import {
  addLog,
  deleteLog,
  editLog,
  getLogs,
  getUserGroupReports,
} from "../../Restclient/datacollection";
import CustomToast from "../CommonComponents/CustomToast";
import CustomDialogBox from "../CommonComponents/CustomDialogBox";

export default function Elogbook() {
  const theme = useSelector((state) => state.themedata.theme);
  const projectId = useSelector(
    (state) => state.mainpagedata.selectedprojectname,
  );
  const username = useSelector((state) => state.logindata.userdetails.UserName);

  const columnHeadings = [
    "S.No.",
    "Date & Time",
    "Message Category",
    "Message",
    "Reported By",
    "Reviewed By",
    "Reviewer Comment",
    "Date & Time of Review",
    "Operation",
  ];

  const [tableRows, setTableRows] = useState([]);

  const [popup, setPopup] = useState(false);
  const [update, setUpdate] = useState(0);
  const [messageCategory, setMessageCategory] = useState("Comment");
  const [message, setMessage] = useState("");
  const [reviewerComment, setReviewerComment] = useState("");
  const [editState, setEditState] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const handleClosePopup = (event, reason) => {
    if (reason === "closeButton") {
      setPopup(false);
      setEditState(0);
      setSelectedRow(null);
      setMessageCategory("Comment");
      setMessage("");
      setReviewerComment("");
    }
  };

  useEffect(() => {
    getLogs((res) => {
      setTableRows(res.data);
    });
  }, [projectId, update]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setUpdate(0);
    }, 3000);
    return () => clearTimeout(timer);
  }, [update]);

  return (
    <Box
      className="compliance-config"
      sx={{ height: "100%", boxSizing: "border-box" }}
    >
      <Box
        sx={{
          padding: "0px",
          height: "calc(100% - 0px)",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            padding: "0px",
            width: "100%",
            height: "7%",
            boxSizing: "border-box",
            display: "flex",
            gap: "8px",
          }}
        >
          <Box sx={{ flexGrow: 1 }}></Box>
          {update === 1 && (
            <CustomToast
              openToast={1}
              type={"Success"}
              autoHideDuration={10000}
              toastText={"Log Added Successfully!"}
              onClose={() => setUpdate(0)}
            />
          )}
          {update === -1 && (
            <CustomToast
              openToast={1}
              type={"Error"}
              autoHideDuration={10000}
              toastText={"Error in Adding Log!"}
              onClose={() => setUpdate(0)}
            />
          )}
          {update === 2 && (
            <CustomToast
              openToast={1}
              type={"Success"}
              autoHideDuration={10000}
              toastText={"Log Deleted Successfully!"}
              onClose={() => setUpdate(0)}
            />
          )}
          {update === -2 && (
            <CustomToast
              openToast={1}
              type={"Error"}
              autoHideDuration={10000}
              toastText={"Error in Deleting Log!"}
              onClose={() => setUpdate(0)}
            />
          )}
          {update === 3 && (
            <CustomToast
              openToast={1}
              type={"Success"}
              autoHideDuration={10000}
              toastText={"Log Edited Successfully!"}
              onClose={() => setUpdate(0)}
            />
          )}
          {update === -3 && (
            <CustomToast
              openToast={1}
              type={"Error"}
              autoHideDuration={10000}
              toastText={"Error in Editing Log!"}
              onClose={() => setUpdate(0)}
            />
          )}
          {update === 4 && (
            <CustomToast
              openToast={1}
              type={"Success"}
              autoHideDuration={10000}
              toastText={"Log Reviewed Successfully!"}
              onClose={() => setUpdate(0)}
            />
          )}
          {update === -4 && (
            <CustomToast
              openToast={1}
              type={"Error"}
              autoHideDuration={10000}
              toastText={"Error in Reviewing Log!"}
              onClose={() => setUpdate(0)}
            />
          )}
          <CustomButton
            onClick={() => setPopup(true)}
            buttonText={"Add"}
            width={"12px"}
          />
        </Box>
        <Box
          sx={{
            boxSizing: "border-box",
            padding: "8px",
            background: "var(--PrimaryBackground)",
            height: "calc(93%)",
            marginBottom: "0px",
            overflow: "auto",
          }}
        >
          <Table stickyHeader sx={{ width: "100%" }} size="small">
            <TableHead>
              <TableRow sx={{ border: "0px" }}>
                {columnHeadings.map((table_head_value, index) => (
                  <TableCell
                    width={table_head_value}
                    key={index}
                    sx={{
                      textAlign: "left",
                      fontSize: "12px",
                      fontWeight: 700,
                      color: "var(--grey-variation-tableLK)",
                      backgroundColor: "var(--primary-backgroundLK)",
                    }}
                  >
                    {table_head_value}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableRows.map((row, rowIndex) => (
                <TableRow
                  key={rowIndex + 1}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    height: "9px",
                    "& > *": {
                      borderBottom: "1px solid var(--table-boarder-line)",
                    },
                  }}
                >
                  <TableCell
                    key={1}
                    component="th"
                    scope="row"
                    sx={{
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "var(--grey-variation-tablerowsLK)",
                    }}
                  >
                    {rowIndex + 1}
                  </TableCell>
                  {row.map(
                    (cell, cellIndex) =>
                      cellIndex < 7 && (
                        <TableCell
                          key={cellIndex + 1}
                          component="th"
                          scope="row"
                          sx={{
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "var(--grey-variation-tablerowsLK)",
                          }}
                        >
                          {cell}
                        </TableCell>
                      ),
                  )}
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "var(--grey-variation-tablerowsLK)",
                    }}
                  >
                    <CustomActionButton
                      buttonText={"Edit"}
                      onClick={() => {
                        setEditState(1);
                        setPopup(true);
                        setSelectedRow(row);
                        setMessageCategory(row[1]);
                        setMessage(row[2]);
                        setReviewerComment(row[5]);
                      }}
                    />
                    <span
                      style={{
                        width: "8px",
                        height: "1px",
                        display: "inline-block",
                      }}
                    ></span>
                    <CustomActionButton
                      buttonText={"Delete"}
                      onClick={() => {
                        setSelectedRow(row);
                        setDeleteOpen(true);
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Box>
      {
        <Dialog
          maxWidth={"l"}
          open={popup}
          onClose={(event, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown") {
              event.preventDefault();
            } else {
              handleClosePopup(event, reason);
            }
          }}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            style: {
              backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
              boxShadow: "none",
              borderRadius: "0px",
            },
          }}
          BackdropProps={{
            style: {
              backgroundColor:
                theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
            },
          }}
        >
          <DialogContent>
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "10px",
                  gap: "8px",
                }}
              >
                <div style={{ flexGrow: 1 }}> </div>
                <div style={{ width: "280px", height: "40px" }}>
                  {update === -5 ? (
                    <CustomLabel
                      fontSize={"6px"}
                      labelText={"You cannot review your own log!"}
                      color={"red"}
                    />
                  ) : update === -6 ? (
                    <CustomLabel
                      fontSize={"6px"}
                      labelText={`${messageCategory === "Comment" ? "Comment" : "Reviewer Comment"} cannot be empty!`}
                      color={"red"}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <CustomButton
                  buttonText={"Save"}
                  onClick={() => {
                    if (
                      (messageCategory === "Comment" &&
                        message.trim() === "") ||
                      (messageCategory === "Reviewed" &&
                        reviewerComment.trim() === "")
                    ) {
                      setUpdate(-6);
                      return;
                    }
                    if (
                      messageCategory === "Reviewed" &&
                      editState === 1 &&
                      selectedRow[3] === username
                    ) {
                      setUpdate(-5);
                      return;
                    }
                    if (editState === 0) {
                      addLog(messageCategory, message, (res) =>
                        setUpdate(res.data),
                      );
                      setPopup(false);
                      setEditState(0);
                      setSelectedRow(null);
                      setMessageCategory("Comment");
                      setMessage("");
                      setReviewerComment("");
                    } else if (editState === 1) {
                      editLog(
                        selectedRow[7],
                        messageCategory,
                        messageCategory === "Reviewed"
                          ? reviewerComment
                          : message,
                        (res) => setUpdate(res.data),
                      );
                      setPopup(false);
                      setEditState(0);
                      setSelectedRow(null);
                      setMessageCategory("Comment");
                      setMessage("");
                      setReviewerComment("");
                    }
                  }}
                />
                <CustomCancelButton
                  buttonText={"Close"}
                  onClick={(event) => handleClosePopup(event, "closeButton")}
                />
              </div>
              <div style={{ backgroundColor: "#FFFFFF" }}>
                <table
                  width="100%"
                  style={{
                    textAlign: "left",
                    padding: "16px 0px 16px 16px",
                    margin: "0px",
                  }}
                >
                  <tr>
                    <td style={{ paddingBottom: "16px", paddingRight: "32px" }}>
                      <CustomLabel
                        htmlFor={"message-category"}
                        labelText={"Message Category*"}
                      />
                    </td>
                    <td style={{ paddingBottom: "16px" }}>
                      <CustomDropDown
                        id={"message-category"}
                        width={227}
                        defaultValue={messageCategory}
                        options={["Comment", "Reviewed"]}
                        disabledOptions={editState === 0 ? ["Reviewed"] : []}
                        onChange={(val) => setMessageCategory(val)}
                      />
                    </td>
                  </tr>
                  {messageCategory === "Comment" ? (
                    <tr>
                      <td
                        style={{ paddingBottom: "16px", paddingRight: "32px" }}
                      >
                        <CustomLabel labelText={"Message*"} />
                      </td>
                      <td style={{ paddingBottom: "16px" }}>
                        <CustomTextField
                          width={227}
                          defaultValue={message}
                          onChange={(val) => setMessage(val)}
                        />
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td
                        style={{ paddingBottom: "16px", paddingRight: "32px" }}
                      >
                        <CustomLabel labelText={"Reviewer Comment*"} />
                      </td>
                      <td style={{ paddingBottom: "16px" }}>
                        <CustomTextField
                          width={227}
                          defaultValue={reviewerComment}
                          onChange={(val) => setReviewerComment(val)}
                        />
                      </td>
                    </tr>
                  )}
                </table>
              </div>
            </>
          </DialogContent>
        </Dialog>
      }
      {
        <CustomDialogBox
          openDialog={deleteOpen}
          dialogTitle={"Delete"}
          dialogText={"Are you sure?"}
          confirmText={"Delete"}
          cancelText={"Cancel"}
          handleCloseDialog={() => {
            setDeleteOpen(false);
            setSelectedRow(null);
          }}
          handleConfirmDialog={() => {
            deleteLog(selectedRow[7], (res) => setUpdate(res.data));
            setDeleteOpen(false);
            setSelectedRow(null);
          }}
          type={"Info"}
        />
      }
    </Box>
  );
}
